// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auto-expand-textarea[data-v-97a917d2] {\n  overflow-y: hidden;\n  resize: none;\n  min-height: 120px;\n}", ""]);
// Exports
module.exports = exports;
